/**
 * Parses a JSON Web Token (JWT) and returns its payload as a JSON object.
 *
 * @param {string} token - The JWT string to be parsed.
 * @returns {Object} The decoded payload of the JWT as a JSON object.
 */
export function parseJwt (token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}